import Image from 'next/image'
import consultationImage from 'public/images/header/clinic-consultation.webp'
import receptionImage from 'public/images/header/clinic-reception.webp'
import waitingRoomImage from 'public/images/header/clinic-waiting-room.webp'

const clinicImages = [consultationImage, waitingRoomImage, receptionImage]

export const HeaderDesktopNavigationClinicImages = () => (
  <div className="grid w-[23.75rem] grid-cols-2 gap-5">
    {clinicImages.map((image) => (
      <Image
        key={image.src}
        src={image}
        alt=""
        sizes="11.25rem"
        className="h-auto w-full rounded-2xl shadow-[0_0.0625rem_0.125rem_rgba(30,48,38,0.04),0_0.75rem_2rem_rgba(30,48,38,0.08)] first:row-span-2"
      />
    ))}
  </div>
)
